module.exports = __webpack_public_path__ + "img/playtime.b23e60ed.png";